<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_3"></a><a id="p9000f15f9970003001">
</a><p class="booktitle">The Beader’s Bible</p><p class="book-title-author">DOROTHY WOOD</p><div class="book-title-imprint"><img alt="" src="images/p9000f15fg3001.png" width="16.69691%"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?332d7b6f